import React from 'react';
import { useStoreon } from 'storeon/react';
import PropTypes from 'prop-types';

import Textarea from '../Textarea';

const BlockContactMethod = (props) => {
  const { index, number = true} = props;
  const { groups } = useStoreon('groups');

  return (
    <fieldset className="form-block" disabled={groups[index].disabled}>
      <legend className="form-block__title">{number ? index + 1 + '. ' : ''}Please provide any additional details to help us process your service request.</legend>
            <div className="row">
        <div className="col col-12 col-sm-8 col-md-7 col-xl-8">
          <Textarea
            name="additional_comments"
            placeholder="Please provide additional details for quicker service"
          />
        </div>
      </div>

      {!groups[index].disabled && groups[index + 1] && groups[index + 1].disabled && (
        <div className={'form-block__error'}>
          You must fill in all required fields prior to moving to the next section.
        </div>
      )}
    </fieldset>
  );
};

BlockContactMethod.propTypes = {
  index: PropTypes.number.isRequired,
};

export default BlockContactMethod;
